/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *
 */
var Platform = {
  OS: 'web',
  select: function select(obj) {
    return 'web' in obj ? obj.web : obj.default;
  },

  get isTesting() {
    if (process.env.NODE_DEV === 'test') {
      return true;
    }

    return false;
  },

  get isTV() {
    return process.env.REACT_APP_IS_TV === 'true';
  }
};
export default Platform;
